// extracted by mini-css-extract-plugin
module.exports = {"actions":"RelatedRoomsSelection_actions__12i-5"};